package store.actions

import it.neckar.common.redux.ChangeType
import it.neckar.lizergy.model.company.user.UserInformation
import store.PlannerClientState

data class UpdateUserAction(val updatedUser: UserInformation) : StateAction {
  override val type: ChangeType = ChangeType.HistoryReset

  override fun PlannerClientState.updateState(): PlannerClientState {
    return this.copy(
      essentials = essentialsNonNull.copy(
        usersAndCompanies = usersAndCompanies.withUpdatedUser(updatedUser),
      ),
    )
  }
}
